export const CAPTURE_AI_SCAN_TYPES_FACILITY_OPTION_NAME = 'capture_ai_scan_types_enabled';

export type FacilityOptionInputType = 'boolean' | 'date' | 'datetime' | 'email-list' | 'text';

export interface FacilityOptionConfig {
    optionName: string;
    displayName: string;
    description: string;
    inputType: FacilityOptionInputType;
    defaultValue: string;
}

export const FACILITY_OPTION_CONFIG: FacilityOptionConfig[] = [
    {
        optionName: 'enableLegacyDailyFacilityScorecard',
        displayName: 'Legacy Daily Facility Scorecard Emails',
        description: 'Enable the legacy daily facility scorecard email configuration for this facility.',
        inputType: 'boolean',
        defaultValue: 'false',
    },
    {
        optionName: 'legacyDailyFacilityScorecardEmails',
        displayName: 'Legacy Daily Facility Scorecard Email Recipients',
        description: 'Enter the scorecard email recipients, one email address per line.',
        inputType: 'email-list',
        defaultValue: '[]',
    },
    {
        optionName: 'integratedVitalsEnabled',
        displayName: 'Vitals Integration',
        description: 'Allow the integrated vitals job to process this facility.',
        inputType: 'boolean',
        defaultValue: 'false',
    },
    {
        optionName: 'encounterScanEnabled',
        displayName: 'Encounter Scans (Capture AI v1)',
        description: 'Allow legacy Capture AI encounter scan documents to be captured and uploaded for this facility.',
        inputType: 'boolean',
        defaultValue: 'false',
    },
    {
        optionName: CAPTURE_AI_SCAN_TYPES_FACILITY_OPTION_NAME,
        displayName: 'Document Types (Capture AI v2)',
        description: 'Allow document type based Capture AI scanning for this facility.',
        inputType: 'boolean',
        defaultValue: 'false',
    },
    {
        optionName: 'includeFullDemographicsInMobileContext',
        displayName: 'Full Demographics in Mobile Context',
        description: 'Include insurance, diagnosis, relation, and guarantor details in mobile encounter context.',
        inputType: 'boolean',
        defaultValue: 'false',
    },
];

export const FACILITY_OPTION_NAMES = FACILITY_OPTION_CONFIG.map((option) => option.optionName);

export function normalizeFacilityOptionValue(optionConfig: FacilityOptionConfig, optionValue: unknown) {
    if (optionConfig.inputType === 'boolean') {
        return String(optionValue).toLowerCase() === 'true' ? 'true' : 'false';
    }
    if (optionConfig.inputType === 'email-list') {
        return normalizeEmailListOptionValue(optionValue);
    }
    const trimmedValue = String(optionValue || '').trim();
    return trimmedValue || optionConfig.defaultValue;
}

function normalizeEmailListOptionValue(optionValue: unknown) {
    const rawValue = String(optionValue || '').trim();
    if (!rawValue) {
        return '[]';
    }

    try {
        const parsedValue = JSON.parse(rawValue);
        if (Array.isArray(parsedValue)) {
            return JSON.stringify(normalizeEmailList(parsedValue));
        }
    } catch {
        // User-edited values can be entered as one email per line instead of raw JSON.
    }

    return JSON.stringify(normalizeEmailList(rawValue.split(/[\n,;]+/)));
}

function normalizeEmailList(values: unknown[]) {
    return values.map((value) => String(value).trim()).filter(Boolean);
}
